import {
  PRESSING_DAMAGE_FAILED,
  PRESSING_DAMAGE_REQUEST,
  PRESSING_DAMAGE_SUCCESS,
} from "../../../../actions/Factory/Pressing/pressingDamage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const pressingDamageReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case PRESSING_DAMAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PRESSING_DAMAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PRESSING_DAMAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
